import React from 'react';

class TCWGlobal extends React.Component {
  render() {
    return (
      <div className="content tcwglobal">
        <p className="content-title"><span>a</span>bstract</p>
        <div className="content-article content-article-paragraphs">
          <img className="tcwglobal-logo" src={require('./../images/tcwglobal_logo.svg')} alt={'TCWGlobal Logo'} />
          <p>
            TCWGlobal is a global workforce solutions company helping organizations hire, manage,
            and support workers throughout the entire employment lifecycle. From hiring and onboarding
            to workforce management, payroll, compliance, and ongoing employee support, TCWGlobal
            provides solutions designed to simplify complex HR operations.
          </p>
          <p>
            By combining workforce expertise with technology, TCWGlobal helps companies manage their
            people and employment processes more efficiently while navigating the operational and
            compliance challenges of a modern global workforce.
          </p>
          <p>
            TCWGlobal continues to evolve its platform and technology to create a more connected and
            streamlined experience for clients, workers, and internal teams.
          </p>
        </div>
        <p className="content-title"><span>e</span>xperience</p>
        <div className="content-article content-article-paragraphs">
          <p>
            I worked as a Full-Stack Software Engineer at TCWGlobal, building software for complex HR and 
            workforce management systems and deepening my understanding of how business processes and 
            technology work together.
          </p>
          <p>
            Working across both legacy and modern systems during a key transition in the company's technology 
            stack, I gained hands-on experience with React and Next.js alongside established backend systems, 
            and incorporated AI-assisted development into my workflow as the field continued to evolve.
          </p>
          <p>
            This role reinforced my belief that strong technical execution comes from a clear understanding 
            of the business behind it. Collaborating with talented engineers and colleagues across teams 
            sharpened my ability to translate business requirements into practical, maintainable, and 
            scalable solutions.
          </p>
        </div>
        <p className="content-title"><span>p</span>rojects</p>
        <div className="content-article">
          <p>• StaffingNation V1</p>
          <p>• StaffingNation V2</p>
        </div>
        <p className="content-title"><span>a</span>chivement</p>
        <div className="content-article content-final">
          <p>• Advanced AI-assisted development practices and workflows</p>
          <p>• Deepened expertise in end-to-end HR & workforce management processes</p>
          <p>• Strengthened business-driven software design and problem-solving skills</p>
        </div>
      </div>
    );
  }
}

export default TCWGlobal;
